export const clone = (value) => {
  if (structuredClone) {
    return structuredClone(value);
  } else {
    return JSON.parse(JSON.stringify(value));
  }
}
